(function () {
  'use strict';

  if (window.HalfomaHomeV2) {
    window.HalfomaHomeV2.initWithin(document);
    return;
  }

  var instances = new WeakMap();

  function focusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (node) {
      return !node.hidden && node.offsetParent !== null;
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.hmHomeReady === 'true') return;
    root.dataset.hmHomeReady = 'true';

    var toggle = root.querySelector('.hm-mobile-menu-toggle');
    var menu = root.querySelector('.hm-nav-sub');
    var closeButton = root.querySelector('.hm-mobile-menu-close');
    var parents = Array.prototype.slice.call(root.querySelectorAll('.hm-nav-parent'));
    var sakuraCopy = root.querySelector('.hm-sakura-story .hm-editorial-copy');
    var mobile = window.matchMedia('(max-width: 1000px)');
    var observer = null;
    var previousFocus = null;
    var inertNodes = [];

    function setBackgroundInert(enabled) {
      Array.prototype.forEach.call(root.children, function (node) {
        if (node === root.querySelector('.hm-nav') || node.classList.contains('hm-topbar')) return;
        if (enabled && !node.inert) {
          node.inert = true;
          inertNodes.push(node);
        }
      });
      if (!enabled) {
        inertNodes.forEach(function (node) { node.inert = false; });
        inertNodes = [];
      }
    }

    function closeSubmenus() {
      parents.forEach(function (button) {
        var item = button.closest('.hm-nav-item');
        if (item) item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      });
    }

    function closeMenu(restoreFocus) {
      if (!menu || !toggle) return;
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('hm-menu-open');
      document.body.classList.remove('hm-menu-open');
      setBackgroundInert(false);
      closeSubmenus();
      if (restoreFocus !== false && previousFocus) previousFocus.focus();
    }

    function openMenu() {
      if (!menu || !toggle) return;
      previousFocus = document.activeElement;
      menu.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('hm-menu-open');
      document.body.classList.add('hm-menu-open');
      setBackgroundInert(true);
      if (closeButton) closeButton.focus();
    }

    function onToggle() { menu.classList.contains('is-open') ? closeMenu() : openMenu(); }
    function onClose() { closeMenu(); }
    function onParent(event) {
      var button = event.currentTarget;
      var item = button.closest('.hm-nav-item');
      var opening = !item.classList.contains('is-open');
      closeSubmenus();
      item.classList.toggle('is-open', opening);
      button.setAttribute('aria-expanded', String(opening));
    }
    function onKeydown(event) {
      if (event.key === 'Escape') {
        if (menu && menu.classList.contains('is-open')) {
          event.preventDefault();
          closeMenu();
        } else {
          closeSubmenus();
        }
        return;
      }
      if (event.key !== 'Tab' || !mobile.matches || !menu || !menu.classList.contains('is-open')) return;
      var items = focusable(menu);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    function onMedia(event) { if (!event.matches) closeMenu(false); }

    if (toggle && menu) toggle.addEventListener('click', onToggle);
    if (closeButton) closeButton.addEventListener('click', onClose);
    parents.forEach(function (button) { button.addEventListener('click', onParent); });
    root.addEventListener('keydown', onKeydown);
    if (mobile.addEventListener) mobile.addEventListener('change', onMedia);
    else mobile.addListener(onMedia);

    if (sakuraCopy) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        sakuraCopy.classList.add('hm-in-view');
      } else {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              sakuraCopy.classList.add('hm-in-view');
              observer.unobserve(sakuraCopy);
            }
          });
        }, { threshold: 0.5 });
        observer.observe(sakuraCopy);
      }
    }

    function destroy() {
      closeMenu(false);
      if (toggle && menu) toggle.removeEventListener('click', onToggle);
      if (closeButton) closeButton.removeEventListener('click', onClose);
      parents.forEach(function (button) { button.removeEventListener('click', onParent); });
      root.removeEventListener('keydown', onKeydown);
      if (mobile.removeEventListener) mobile.removeEventListener('change', onMedia);
      else mobile.removeListener(onMedia);
      if (observer) observer.disconnect();
      root.removeAttribute('data-hm-home-ready');
      instances.delete(root);
    }

    instances.set(root, { destroy: destroy });
  }

  function rootsWithin(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-hm-home]')) roots.push(scope);
    if (scope && scope.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-hm-home]')));
    return roots;
  }

  function initWithin(scope) { rootsWithin(scope || document).forEach(initRoot); }
  function destroyWithin(scope) { rootsWithin(scope).forEach(function (root) { var instance = instances.get(root); if (instance) instance.destroy(); }); }
  function boot() { initWithin(document); }

  window.HalfomaHomeV2 = { initWithin: initWithin, destroyWithin: destroyWithin };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroyWithin(event.target); });
})();
